import store from "../store/store.js";
import axios from "../axios.js";
import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = "accessToken";

class AuthService {
    idToken = null;
    profile = null;
    tokenExpiry = null;

    // Starts the user login flow
    login(customState) {}

    // Starts the user login flow
    localLogin(authResult) {}

    logOut() {}

    isAuthenticated() {
        const token = localStorage.getItem(TOKEN_KEY);

        if (!token) {
            return false;
        }

        try {
            const decoded = jwtDecode(token);

            // check if the token is expired
            if (decoded.exp < Date.now() / 1000) {
                return false;
            }

            return true;
        } catch (error) {
            return false;
        }
    }

    async updateToken(token) {
        // console.log("------> UPDATE_TOKEN", token);
        localStorage.setItem(TOKEN_KEY, token);
        // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        // const decoded = jwtDecode(token);
        // console.log("decoded.exp", decoded.exp);

        // // auto refresh token 5 minutes before it expires
        // const refreshAt = decoded.exp - 300;
        // console.log("refreshAt", refreshAt);
    }

    logout() {
        localStorage.removeItem(TOKEN_KEY);
    }

    // getUser() {
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .get("/auth/user")
    //             .then((response) => {
    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //             });
    //     });
    // }

    // refreshToken() {
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .post("/auth/refresh-token")
    //             .then((response) => {
    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //             });
    //     });
    // }
}

export default new AuthService();
